import boffinAppSettings from "src/Ateam-BI/Boffin/app_settings";
import tedAppSettings from "src/Ateam-BI/Ted/app_settings";
import corpReportingAppSettings from "src/Ateam-BI/CorpReporting/app_settings";

/**
 * Determines the app_id for view count tracking based on the current path.
 * Returns the app_id if the path matches a tracked route, or null if not.
 * For /App/:id routes, extracts the id from the URL.
 * For custom-URL apps (Boffin, TED, CorpReporting), uses predefined app IDs from app_settings.
 */
export const getAppIdForViewCount = (path: string, stage: string): string | null => {
    const lowerPath = path?.toLowerCase() || "";

    // /App/:id routes - extract id from URL
    const appRouteMatch = path.match(/^\/App\/(\d+)/i);
    if (appRouteMatch) {
        return appRouteMatch[1];
    }

    // Custom-URL apps - map to predefined app IDs from app_settings
    if (lowerPath.includes("boffin")) {
        return boffinAppSettings.appId;
    } else if (lowerPath.includes("corpreporting")) {
        const stageSettings = (corpReportingAppSettings as Record<string, { appId: string }>)[stage] || corpReportingAppSettings.prod;
        return stageSettings.appId;
    } else if (
        lowerPath.includes("tedhome") ||
        lowerPath.includes("triggereventlogs") ||
        lowerPath.includes("triggerhistory") ||
        lowerPath.includes("emailsubscription") ||
        lowerPath.includes("entityregionmapping") ||
        lowerPath.includes("regiontriggermapping")
    ) {
        return tedAppSettings.appId;
    }

    return null;
};
